<template>
    <div class="sidebar -courses">
        <!-----start of categories filter -------->
        <div class="sidebar__item">
            <div class="items-center">
                <h4 class="sidebar__title">{{ $t('sidebar.categories') }}</h4>
            </div>
            <!----<div class="sidebar-checkbox">
                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="development" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="development" class="sidebar-checkbox__title">
                        Development
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="business" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="business" class="sidebar-checkbox__title">
                        Business
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="finance" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="finance" class="sidebar-checkbox__title">
                        Finance & Accounting
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="productivity" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="productivity" class="sidebar-checkbox__title">
                        Office Productivity
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="marketing" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="marketing" class="sidebar-checkbox__title">
                        Marketing
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="health" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="health" class="sidebar-checkbox__title">
                        Health & Fitness
                    </label>
                </div>
            </div>-->
            <div class="sidebar-checkbox">
                <div v-for="(category) in categories" :key="category.value">
                    <div class="sidebar-checkbox__item mb-2">
                        <div class="form-checkbox">
                            <input type="checkbox" :id="category.value" v-model="selectedCategories"
                                :value="category.value" @change="emitSelectedCategories" />
                            <div class="form-checkbox__mark">
                                <div class="form-checkbox__icon icon-check">
                                    <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                        viewBox="0 0 24 24">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <label :for="category.value" class="sidebar-checkbox__title">
                            {{ category.label }}
                        </label>

                    </div>
                    <!-- Recursively render children if they exist -->
                    <div v-if="category.children && category.children.length" class="sidebar-checkbox__children">
                        <div class="sidebar-checkbox__item mb-2" v-for="(child) in category.children"
                            :key="child.value">
                            <div class="form-checkbox">
                                <input type="checkbox" :id="child.value" v-model="selectedCategories"
                                    :value="child.value" @change="emitSelectedCategories" :checked="child.value == selectedCategories"/>
                                <div class="form-checkbox__mark">
                                    <div class="form-checkbox__icon icon-check">
                                        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                            viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <label :for="child.value" class="sidebar-checkbox__title">
                                {{ child.label }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-----End of categories filter -------->

        <!-----start of course level filter-------------
        <div class="sidebar__item">
            <div>
                <h4 class="sidebar__title">Course Level</h4>
            </div>
            <div class="sidebar-checkbox">
                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="levels" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="levels" class="sidebar-checkbox__title">
                        All Levels
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="beginner" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="beginner" class="sidebar-checkbox__title">
                        Beginner
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="intermediate" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="intermediate" class="sidebar-checkbox__title">
                        Intermediate
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="advanced" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="advanced" class="sidebar-checkbox__title">
                        Advanced
                    </label>
                </div>
            </div>
        </div>-->
        <!-----end of course level filter------------->

        <!------start of language filter---------
        <div class="sidebar__item">
            <div>
                <h5 class="sidebar__title">Languange</h5>
            </div>
            <div class="sidebar-checkbox">
                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="arabic" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <label for="arabic" class="sidebar-checkbox__title">
                        Arabic
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="english" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <label for="english" class="sidebar-checkbox__title">
                        English
                    </label>
                </div>
            </div>
        </div>-->
        <!------end of language filter--------->
        <!------start of rating filter--------
        <div class="sidebar__item">
            <div>
                <h4 class="sidebar__title">rating</h4>
            </div>
            <div class="sidebar-checkbox">
                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="rating-1" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <label for="rating-1" class="sidebar-checkbox__title">
                        4 stars and above
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="rating-2" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <label for="rating-2" class="sidebar-checkbox__title">
                        4.5 stars and above
                    </label>
                </div>

                <div class="sidebar-checkbox__item">
                    <div class="form-checkbox">
                        <input type="checkbox" id="rating-3" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <label for="rating-3" class="sidebar-checkbox__title">
                        5 stars
                    </label>
                </div>
            </div>
        </div>
        ------end of rating filter-------->

        <!------start of Instructor filter-------->
        <div class="sidebar__item">
            <div>
                <h4 class="sidebar__title">{{ $t('sidebar.instructors') }}</h4>
            </div>

            <div>
                <div>
                    <div class="sidebar-checkbox">
                        <div class="sidebar-checkbox__item" v-for="instructor in instructors" :key="instructor.id">
                            <div class="form-checkbox">
                                <!-- Use v-model to bind the checkbox to the selectedInstructors array -->
                                <input type="checkbox" :id="'instructor-' + instructor.id" v-model="selectedInstructors"
                                    :value="instructor.id" @change="emitSelectedinstractors" />
                                <div class="form-checkbox__mark">
                                    <div class="form-checkbox__icon icon-check">
                                        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                            viewBox="0 0 24 24">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <label :for="'instructor-' + instructor.id" class="sidebar-checkbox__title">
                                {{ instructor.name }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!------end of Instructor filter-------->

        <!------start of Price filter--------
        <div class="sidebar__item">
            <div>
                <div>
                    <h4 class="sidebar__title mb-25">Price</h4>
                </div>
                start of price range slider-------------
                <div class="sidebar-content -slider">
                    <div class="js-price-rangeSlider">
                        <div class="px-5">
                            <div class="js-slider"></div>
                        </div>

                        <div class="mt-25">
                         

                            <price-filter @priceUpdate="updatePriceRange" />
                        </div>
                    </div>
                </div>

                ------------free or not checkbox---------
                <div class="sidebar-checkbox__item mt-20">
                    <div class="form-checkbox">
                        <input type="checkbox" id="free" />
                        <div class="form-checkbox__mark">
                            <div class="form-checkbox__icon icon-check">
                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                    viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <label for="free" class="sidebar-checkbox__title capitalize ml-10">
                        free
                    </label>
                </div>
                ---------
            </div>
        </div>-->
    </div>
</template>
<script>
import PriceFilter from "./PriceFilter.vue";
import store from "@/store";
export default {
    name: "FiltersComponent",
    components: {
        PriceFilter,
    },
    data() {
        return {
            selectedLowerPrice: 0,
            selectedUpperPrice: 500,
            categories: [], 
            selectedCategories: [],
            instructors: [],
            selectedInstructors: [],
        };
    },
    computed: {
        categories() {
            return this.$store.getters.categories
        },
        instructors() {
            return this.$store.getters.instructors
        }
    },
    methods: {
        updatePriceRange({ lowerPrice, upperPrice }) {
            this.selectedLowerPrice = lowerPrice;
            this.selectedUpperPrice = upperPrice;
        },
        emitSelectedCategories() {
            this.$store.dispatch("addSelectedCatgories", this.selectedCategories)
           // this.$emit("update:selectedCategories", this.selectedCategories);
        },
        emitSelectedinstractors() {
            this.$store.dispatch("addSelectedInstructor", this.selectedInstructors);
        },
    },
    mounted() {
      //  store.dispatch("categoriesList");
      //  store.dispatch("instructorsList");
        this.selectedCategories =  store.getters.selectedCategories;
    }
};
</script>
